import {
  Star,
  AlertTriangle,
  CheckCircle2,
  XCircle,
  Image as ImageIcon,
  ClipboardList,
  MessageCircle,
  Target,
  Clock,
  Hourglass,
  Lightbulb,
  TrendingUp,
  TrendingDown,
  Search,
  Rocket,
  Trophy,
  Sparkles,
  Megaphone,
  MapPin,
  Phone,
  Mail,
  Globe,
  Lock,
  Unlock,
  ThumbsUp,
  ThumbsDown,
  AlertCircle,
  Info,
  Flag,
  Award,
  ShieldCheck,
  Zap as Bolt,
  FileText,
  BarChart3,
  Bot,
  Turtle,
  type LucideIcon,
} from 'lucide-react';

/**
 * Map common emoji characters to a lucide icon component. Used to render
 * LLM-generated content (audit insights, etc.) that historically embedded
 * pictorial emojis. Returns null when the input doesn't match any known emoji
 * so callers can fall back.
 */
const EMOJI_TO_ICON: Record<string, LucideIcon> = {
  '⭐': Star,
  '🌟': Star,
  '✨': Sparkles,
  '🏆': Trophy,
  '🎖': Award,
  '🥇': Award,
  '⚠': AlertTriangle,
  '⚠️': AlertTriangle,
  '❗': AlertCircle,
  '❌': XCircle,
  '✅': CheckCircle2,
  '✔️': CheckCircle2,
  '✓': CheckCircle2,
  ℹ: Info,
  ℹ️: Info,
  '💡': Lightbulb,
  '🎯': Target,
  '🚀': Rocket,
  '⚡': Bolt,
  '⏳': Hourglass,
  '⏱': Clock,
  '⏰': Clock,
  '📊': BarChart3,
  '📈': TrendingUp,
  '📉': TrendingDown,
  '📋': ClipboardList,
  '📝': FileText,
  '📄': FileText,
  '🔍': Search,
  '🔎': Search,
  '💬': MessageCircle,
  '🖼': ImageIcon,
  '🖼️': ImageIcon,
  '📷': ImageIcon,
  '📣': Megaphone,
  '📢': Megaphone,
  '📍': MapPin,
  '📞': Phone,
  '📧': Mail,
  '🌐': Globe,
  '🔒': Lock,
  '🔓': Unlock,
  '👍': ThumbsUp,
  '👎': ThumbsDown,
  '🚩': Flag,
  '🛡': ShieldCheck,
  '🛡️': ShieldCheck,
  '🤖': Bot,
  '🐌': Turtle,
};

export function emojiToIcon(input: string | undefined | null): LucideIcon | null {
  if (!input) return null;
  return EMOJI_TO_ICON[input.trim()] ?? null;
}
